import { PropsWithChildren, useEffect, useRef } from 'react';
import { useRemoveBodyScroll } from '@lamimed/utils';

import * as S from './styles';

export type Props = PropsWithChildren & {
  open: boolean;
  onClose: () => void;
};

export function Drawer({ onClose, open, children }: Props) {
  const backdropRef = useRef<HTMLDivElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);

  useRemoveBodyScroll(open);

  useEffect(() => {
    const backdrop = backdropRef.current;

    const handleClose = ({ key }: KeyboardEvent) => {
      if (key === 'Escape') {
        onClose();
      }
    };

    const handleClick = ({ target }: MouseEvent) => {
      const hasElement = drawerRef?.current?.contains(target as Node);

      if (!hasElement) return onClose();
    };

    window.addEventListener('keydown', handleClose, false);

    backdrop?.addEventListener('click', handleClick, false);

    return () => {
      window.removeEventListener('keydown', handleClose, false);

      backdrop?.removeEventListener('click', handleClick, false);
    };
  }, [onClose]);

  return (
    <S.Backdrop ref={backdropRef} open={open}>
      <S.Container ref={drawerRef}>{children}</S.Container>
    </S.Backdrop>
  );
}
